// Chainable no-op for native modules that are CALLED (not rendered): device
// info, analytics, idfa, sentry, sms-retriever, payments, firebase, etc.
// Every property is another chainable proxy and every call returns one, so
// `DeviceInfo.getX()`, `analytics.log()`, `IDFA.getIDFA().then(cb)` never throw.
//
// CRITICAL: the proxy is a thenable (has `.then`) so explicit `.then(cb)` works,
// but `then` MUST resolve to a NON-thenable (undefined). If it resolved to
// another noop (also a thenable), the JS promise-resolution procedure would
// recursively resolve thenable→thenable forever, hanging the main thread on
// `await nativeStub` / `Promise.resolve(nativeStub)`. Resolving to undefined
// terminates resolution.
function createNoop() {
  const fn = function () {
    return createNoop();
  };
  return new Proxy(fn, {
    get(_t, prop) {
      if (prop === "__esModule") return true;
      if (prop === "default") return root;
      if (prop === "then") {
        return function (onF) {
          if (typeof onF === "function") { try { onF(undefined); } catch (_) {} }
          return Promise.resolve(undefined); // real, terminal promise
        };
      }
      if (prop === "catch") return function () { return Promise.resolve(undefined); };
      if (prop === "finally") {
        return function (cb) {
          if (typeof cb === "function") { try { cb(); } catch (_) {} }
          return Promise.resolve(undefined);
        };
      }
      if (prop === Symbol.toPrimitive) return () => "";
      if (typeof prop === "symbol") return undefined;
      return createNoop();
    },
    apply() {
      return createNoop();
    },
  });
}
const root = createNoop();
module.exports = root;
